import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf, VariablesOf } from 'gql.tada';

// Posts a selection of invoices that may span families. The backend groups the
// ids by family and posts each family on its own, so one family's refusal
// lands on that family's result and the others still go through; the payload
// says what happened to every row, including the ones it skipped.
const PostSchoolInvoicesMutation = graphql.persisted(
  "PostSchoolInvoices",
  graphql(`
    mutation PostSchoolInvoices($input: PostSchoolInvoicesInput!) {
      postSchoolInvoices(input: $input) {
        success
        familyCount
        pushedCount
        families {
          familyEnrollmentId
          familyName
          pushedCount
          message
          warnings
          rows {
            invoiceId
            action
            message
            feeCents
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export type PostSchoolInvoicesInput = VariablesOf<typeof PostSchoolInvoicesMutation>['input'];
export type PostSchoolInvoicesPayload = NonNullable<
  ResultOf<typeof PostSchoolInvoicesMutation>['postSchoolInvoices']
>;
export type PostSchoolInvoicesFamily = PostSchoolInvoicesPayload['families'][number];

export { PostSchoolInvoicesMutation };

export function usePostSchoolInvoices() {
  return useMutation(PostSchoolInvoicesMutation);
}
